import { Dimensions, Platform, StyleSheet } from 'react-native';
import colors from '@/config/colors';

const isWeb = Platform.OS === 'web';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 16,
  },
  card: { flex: 1 },
  containerItem: {
    flex: 1,
    alignItems: 'stretch',
    borderRadius: 3,
  },
  containerItemHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: 10,
  },
  containerItemHeaderText: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flexShrink: 1,
    flexWrap: 'wrap',
    marginRight: 8,
  },
  title: {
    fontSize: 20,
    fontWeight: '700',
    color: colors.darkGrey,
  },
  titleSize: {
    fontSize: 10,
    fontWeight: '700',
    color: colors.newUI.therapist.textBlue100,
  },
  containerItemHeaderBtn: {
    padding: 10,
    borderRadius: 50,
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerItemBody: {
    flex: 1,
  },
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    marginVertical: 5,
  },
  rowImage: {
    height: isWeb ? 90 : 60,
    width: isWeb ? 90 : 60,
    borderRadius: 2,
  },
  rowFlexOne: {
    flex: 1,
  },
  rowFlexThree: {
    flex: 3,
  },
  tagsTitle: {
    margin: 5,
    fontSize: 18,
    color: colors.darkGrey,
    fontWeight: '600',
  },
  tagsContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 4,
  },
  tag: {
    paddingHorizontal: 8,
    paddingVertical: 4,
    backgroundColor: colors.lightBlue,
    borderRadius: 8,
  },
  tagText: {
    fontSize: 12,
    color: colors.black,
  },
  rowContainerAction: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContainer: {
    backgroundColor: colors.white,
    borderRadius: 2.5,
    width:
      Platform.OS === 'web'
        ? Dimensions.get('window').width / 2.5
        : Dimensions.get('window').width / 1.5,
  },
  modalHeader: {
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: 15,
    borderBottomWidth: 1,
    borderBottomColor: '#cccc',
  },
  modalBody: {
    padding: 10,
  },
  modalBodyInput: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalBodyInputLabel: {
    marginHorizontal: 10,
    fontSize: 11,
    marginVertical: 5,
    color: '#bbbb',
  },
  modalFooter: {
    marginTop: 25,
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  modalFooterBtn: {
    flex: 1,
    padding: 10,
    borderRadius: 3,
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalFooterBtnText: {
    fontSize: 16,
  },
  redBackgroundColor: {
    backgroundColor: 'red',
  },
  greenBackgroundColor: {
    backgroundColor: colors.primary,
  },
  greyBackgroundColor: {
    backgroundColor: '#cccc',
  },
  marginRight: {
    marginRight: 10,
  },
  seperator: {
    height: 1,
    backgroundColor: colors.darkGrey,
    marginHorizontal: 10,
  },
});
